export default "__VITE_ASSET__FrI7SSA9__"